import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15v4.555c-.344.032-.687.066-1.03.1a5 5 0 0 0-4.46 4.376C6.17 26.851 6 30.195 6 34.065c0 1.387.022 2.619.066 3.694a7 7 0 0 0 6.385 6.689C16.665 44.816 20.514 45 24 45c3.485 0 7.333-.184 11.545-.552a7 7 0 0 0 6.385-6.677c.047-1.104.07-2.372.07-3.803 0-3.844-.168-7.156-.505-9.939a5 5 0 0 0-4.46-4.373c-.344-.035-.69-.068-1.035-.1V15c0-6.627-5.373-12-12-12S12 8.373 12 15Zm12 6c4.31 0 8.589.215 12.834.646a3 3 0 0 1 2.675 2.624c.327 2.695.491 5.929.491 9.698a89.02 89.02 0 0 1-.068 3.718 5 5 0 0 1-4.561 4.77C31.214 42.819 27.423 43 24 43c-3.425 0-7.217-.181-11.375-.544a5 5 0 0 1-4.561-4.778A90.068 90.068 0 0 1 8 34.065c0-3.795.166-7.06.496-9.794a3 3 0 0 1 2.675-2.625C15.415 21.216 19.691 21 24 21Zm-6 8a6 6 0 1 1 10 4.472V37a4 4 0 0 1-8 0v-3.528A5.988 5.988 0 0 1 18 29Zm4 4a1 1 0 0 0-.4-.8 4 4 0 1 1 4.799 0A1 1 0 0 0 26 33v4a2 2 0 1 1-4 0v-4Zm-2-13.939V15a4 4 0 0 1 8 0v4.061a130.474 130.474 0 0 0-8 0ZM30 15v4.138c1.336.062 2.67.144 4 .247V15c0-5.523-4.477-10-10-10S14 9.477 14 15v4.385a128.71 128.71 0 0 1 4-.247V15a6 6 0 0 1 12 0Z",
    fill: "currentColor"
  }));
};

var SvgLocked = styled(SvgComponent).withConfig({
  displayName: "Locked__SvgLocked",
  componentId: "sc-7xo6ti-0"
})(["", " ", ""], size, color);
export default SvgLocked;